/* src/app/components/payment/info-row/info-row.component.scss */
.row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.5rem 0;
}
.row .row-left {
  font-weight: 500;
  flex: 1;
}
.row .row-right {
  font-weight: 600;
  text-align: right;
}
/*# sourceMappingURL=info-row.component.css.map */
